import styled from 'styled-components';

export const Container = styled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  paddingTop: '1.25rem',
});

export const List = styled.div({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '20rem',
  overflowX: 'auto',
  overflowY: 'hidden',

  '&::webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  '-ms-overflow-style': 'none',

  '& > *:last-child': {
    marginRight: '1.5rem',
  },
});
